import { useState } from 'react';
import { useNavScroll } from '../../hooks/useScrollAnimation';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Mission & Vision', href: '#mission-vision' },
  { label: 'Products', href: '#products' },
  { label: 'Suppliers', href: '#suppliers' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const scrolled = useNavScroll();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-sm border-b border-stone-100'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="#home"
            onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }}
            className="flex items-center gap-3 cursor-pointer"
          >
            <img
              src={
                scrolled
                  ? 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/48b3f4d1-59a6-4f4c-9d2c-d08c4a2c0b75_VBMex_logo_FINAL_outlined_bluecolor-02.png?v=2d38591f5f89793d75d3eb9c1682ba7b'
                  : 'https://storage.readdy-site.link/project_files/dd5028de-19b2-46ba-b682-1ec36c54fca8/5db9c1e3-0a1e-4d0e-9cb5-e34adc163391_VBMex_logo_FINAL_outlined_white.png?v=be7e012dd9afe28ef833797c3d588c04'
              }
              alt="VBMex LLC Logo"
              className="h-16 w-auto object-contain transition-all duration-500"
            />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className={`text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? 'text-stone-700 hover:text-[#2D5E3F]'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA + Mobile Toggle */}
          <div className="flex items-center gap-4">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
              className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-[#2D5E3F] text-white text-sm font-medium rounded-full hover:bg-[#1C3A2C] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Request a Quote
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
            <button
              className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-xl ${scrolled ? 'text-stone-700' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-stone-100">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="text-stone-700 text-sm font-medium py-2 border-b border-stone-50 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); handleNavClick('#contact'); }}
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 bg-[#2D5E3F] text-white text-sm font-medium rounded-full cursor-pointer whitespace-nowrap"
            >
              Request a Quote
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
